module.exports = __webpack_public_path__ + "static/media/Mapa-Tocantins.4b524cd2.svg";